module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcthigh0-8d9bd5f4ba5194024c097fe44da5c713.jpg";